import React from 'react';
import { Star } from 'lucide-react';

const RatingStars = ({ rating, onRatingChange, size = 'w-5 h-5', interactive = false }) => {
  const stars = [1, 2, 3, 4, 5];

  return (
    <div className="flex items-center gap-1">
      {stars.map((star) => (
        <button
          key={star}
          type="button"
          onClick={() => interactive && onRatingChange && onRatingChange(star)}
          disabled={!interactive}
          className={`${interactive ? 'cursor-pointer hover:scale-110' : 'cursor-default'} transition-transform duration-150`}
        >
          <Star
            className={`${size} ${
              star <= (rating || 0)
                ? 'text-yellow-500 fill-yellow-500'
                : 'text-gray-300'
            }`}
          />
        </button>
      ))}
      {rating && (
        <span className="ml-2 text-sm font-medium" style={{color: 'var(--brand-navy)'}}>
          {rating}.0
        </span>
      )}
    </div>
  );
};

export default RatingStars;